<template>
  <main class="membership-page">
    <div class="membership-page__header">
      <h1 class="membership-page__title">Membership & Billing</h1>
      <p class="membership-page__subtitle">Manage your subscription and billing details.</p>
    </div>

    <div class="membership-page__top-grid">
      <MembershipStatusCard />
      <ActivationCode />
    </div>

    <div class="membership-page__mid-grid">
      <MembershipPaymentMethod />
      <MembershipBillingInfo />
    </div>

    <InvoiceHistory />
  </main>
</template>

<script>
import MembershipStatusCard from '../membership/MembershipStatusCard.vue';
import MembershipPaymentMethod from '../membership/MembershipPaymentMethod.vue';
import MembershipBillingInfo from '../membership/MembershipBillingInfo.vue';
import ActivationCode from '../ActivationCode.vue';
import InvoiceHistory from '../InvoiceHistory.vue';

export default {
  name: 'MembershipPage',
  components: {
    MembershipStatusCard,
    MembershipPaymentMethod,
    MembershipBillingInfo,
    ActivationCode,
    InvoiceHistory,
  },
};
</script>

<style lang="scss" scoped>
.membership-page {
  padding: 2rem;
  max-width: 960px;
  width: 100%;

  &__header {
    margin-bottom: 1.5rem;
  }

  &__title {
    font-family: $font-stack-heading;
    font-size: 1.75rem;
    text-transform: uppercase;
    margin: 0 0 0.3rem;
    color: $color-black;
    letter-spacing: 0.02em;
  }

  &__subtitle {
    font-size: 0.875rem;
    color: $fc-greyscale-800;
    margin: 0;
  }

  &__top-grid,
  &__mid-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-bottom: 1rem;

    @media #{$tablet-up} {
      grid-template-columns: 1fr 1fr;
    }
  }
}
</style>
